const CONTENT_BASE =
  "https://raw.githubusercontent.com/enisaeu/euvd-docs-public/main";

export async function fetchMarkdown(slug, { signal } = {}) {
  const res = await fetch(`${CONTENT_BASE}/${slug}.md`, {
    cache: "no-store",
    signal,
  });
  if (!res.ok) {
    throw new Error(`content fetch failed: ${res.status}`);
  }
  return res.text();
}
